import axiosInstance from "services/AxiosInstance";

export const getCostCenterService = async (id: string) => {
  const response = await axiosInstance.get(`/costcenter/${id}`);
  return response.data;
};
